import React from 'react'
import TaskCardSettingBar from '../TaskCardModal2023/TaskCardSettingBar/TaskCardSettingBar'
import Subtask2023 from '../TaskCardModal2023/Subtask2023/Subtask2023'
import { taskCardAnimateIn, taskCardAnimateOut, freshSubtask } from '../AdminTasks/adminTaskUtils'
import { baseUrl } from '../assets/Animations'
import axios from 'axios'
import './onboarding-card-modal-2023.css'
import LooksLikeYouAreDonePopup from '../WorfklowCardModal2023/LooksLikeYouAreDonePopup/LooksLikeYouAreDonePopup'

const myToken = localStorage.getItem('token')
const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

const OnboardingCardModal2023 = ({openWorkflowModal2023, setOpenWorkflowModal2023, deleteItem, updateItem, setShowNotes}) => {
    const [isPopupOpen, setIsPopupOpen] = React.useState(false)
    React.useEffect(() => taskCardAnimateIn('onboarding-card-modal-2023__wrapper', 'onboarding-card-modal-2023'), [])

    const checkForAutoClear = (val) => {
        val === "New Task..." && setOpenWorkflowModal2023({...openWorkflowModal2023, todoName: ''})
    }

    const saveAndCloseTask = () => {
        setShowNotes(false)
        taskCardAnimateOut('onboarding-card-modal-2023__wrapper', 'onboarding-card-modal-2023')
        axios.put(`${baseUrl}/onboarding/${openWorkflowModal2023.todoId}`, openWorkflowModal2023, myHeader)
        .then((res) => {
            updateItem(res.data, 'todoId')
            //setWorkflows(prev => (prev.map((todo) => todo.todoId === res.data.todoId ? res.data : todo)))
            setOpenWorkflowModal2023(false)
        })
        .catch((err) => console.log(err))
    }

    const deleteAndCloseTask = () => {
        setShowNotes(false)
        taskCardAnimateOut('onboarding-card-modal-2023__wrapper', 'onboarding-card-modal-2023')
        axios.delete(`${baseUrl}/onboarding/${openWorkflowModal2023.todoId}`, myHeader)
        .then((res) => {
            deleteItem(res.data, 'todoId')
            //setWorkflows(prev => (prev.filter((todo) => todo.todoId !== res.data.todoId && todo)))
            setOpenWorkflowModal2023(false)
        })
        .catch((err) => console.log(err))
    }

    return(
        <div className='onboarding-card-modal-2023__wrapper' id='onboarding-card-modal-2023__wrapper' onClick={(e) => e.target.id === 'onboarding-card-modal-2023__wrapper' && (openWorkflowModal2023.todoSubtasks.filter((sub) => !sub.subtaskCompleted && sub).length > 0 ? saveAndCloseTask() : setIsPopupOpen(true))}>
            {isPopupOpen && <LooksLikeYouAreDonePopup saveAndCloseTask={saveAndCloseTask} deleteAndCloseTask={deleteAndCloseTask} />}
            <div className='onboarding-card-modal-2023' id='onboarding-card-modal-2023'>
                <input className='onboarding-card-modal-2023__task-name' value={openWorkflowModal2023.todoName} onClick={(e) => checkForAutoClear(e.target.value)} onChange={(e) => setOpenWorkflowModal2023({...openWorkflowModal2023, todoName: e.target.value})} />
                <TaskCardSettingBar openModal2023={openWorkflowModal2023} setOpenModal2023={setOpenWorkflowModal2023} />
                <div className='onboarding-card-modal-2023__subtask__wrapper'>
                    {openWorkflowModal2023.todoSubtasks.map((subtask) => <Subtask2023 key={subtask.subtaskId} subtask={subtask} setOpenModal2023={setOpenWorkflowModal2023} />)}
                    <div className='onboarding-card-modal-2023__add-subtask' onClick={() => setOpenWorkflowModal2023({...openWorkflowModal2023, todoSubtasks: [...openWorkflowModal2023.todoSubtasks, freshSubtask()]})}>+ Add Subtask</div>
                </div>
            </div>
        </div>
    )
}
export default OnboardingCardModal2023